module.exports = __webpack_public_path__ + "img/Certificate_Desktop@2x.1a20e79.webp";